import React, { useState, useEffect, useCallback } from "react";
import { IconButton, Drawer, Button, TextField, MenuItem, Tooltip, } from "@mui/material";
import { Row, Col, Card, Modal } from "react-bootstrap";
import { HeadingTwo, HeadingFour } from "../../Common/Components";
import swal from "sweetalert2";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { dateFormat, ApproverDepartments } from "../../Common/Constants/staticjson"
import { useNavigate, Link } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { getRequest, postRequest, patchRequest } from "../../Common/api/apiService";
import { Edit, Delete } from "@mui/icons-material";
import ProjectTimeSheetForm from "../ProjectTimeSheetForm";
import CommonDataGrid from "../../Common/commonDataGrid";
import { useDispatch, useSelector } from "react-redux";
import { GrOverview } from "react-icons/gr";
import { setPagination, setSortModel, resetState, resetPage } from "../../ReduxToolkit/taskSlice.js";
import {
  TableBody,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";

export default function MyTaskManage() {

  const navigate = useNavigate()
  const [projectTask, setProjectTask] = useState([]);
  const [projectList, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchFilters, setSearchFilters] = useState({ project: "", department: "" });
  const dispatch = useDispatch();
  const paginationModel = useSelector(state => state.task.pagination);
  const sortModel = useSelector(state => state.task.sortModel);
  const searchText = useSelector(state => state.task.searchText);
  const [rowCount, setRowCount] = useState(0);

  // --- Drawer ---
  const [timeSheetDrawerState, setTimeSheetDrawerState] = useState(false);
  const [editId, setEditId] = useState("");
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);



  const [dates, setDates] = useState({
    startDate: moment().subtract(6, "days"),
    endDate: moment(),
  });

  const ranges = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  }


  // --- Search Reset ---
  const resetFilters = () => {
    setSearchFilters({ department: "", project: "" });
    setDates({
      startDate: moment().subtract(6, "days"),
      endDate: moment(),
    });
    dispatch(resetState());
    loadMyTask();

  };

  const handleViewTask = (task) => {
    setSelectedTask(task);
    setShowTaskModal(true);
  };

  const handleCloseModal = () => {
    setShowTaskModal(false);
    setSelectedTask(null);
  };



  const loadMyTask = useCallback(async () => {
    setLoading(true);

    const { page, pageSize } = paginationModel;
    const sortField = sortModel[0]?.field || "projectOrTicket";

    const sortOrder = sortModel[0]?.sort;
    const sortQuery = sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : "";

    const { project, department } = searchFilters;
    const startDate = dates.startDate ? dates.startDate.format("YYYY-MM-DD") : "";
    const endDate = dates.endDate ? dates.endDate.format("YYYY-MM-DD") : "";

    const query = `fetch-specific-employee-overall-task-details?page=${page}&limit=${pageSize}&dept=${department}&project=${project}&startDate=${startDate}&endDate=${endDate}${sortQuery}&query=${encodeURIComponent(searchText)}`;

    try {
      const response = await getRequest(query);
      if (response?.data) {
        setProjectTask(response.data.fetchedItems || []);
        setRowCount(response.data.totalItems || 0);
      }
    } catch (error) {
      swal.fire({
        text: error.response?.data?.message || "Failed to fetch tasks.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  }, [paginationModel, sortModel, searchFilters, dates, searchText]);


  useEffect(() => {
    loadMyTask();
  }, [loadMyTask]);



  const loadProjects = useCallback(async () => {
    setLoading(true);
    const query = `fetchprojects`;
    try {
      const response = await postRequest(query);
      if (response?.data) {
        setProjects(response.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const deleteTimeSheet = useCallback(
    async (id, tms_Task_Brand) => {
      setLoading(true);
      const query = `delete-emp-daily-task/${id}/${tms_Task_Brand}`;
      try {
        const response = await patchRequest(query, {});
        if (response?.status === 200) {
          await swal.fire({
            text: "Successfully Deleted",
            icon: "success",
          });
          loadMyTask();
        }
      } catch (error) {
        swal.fire({
          text: error.response?.data || "Error deleting timesheet",
          icon: "error",
        });
      } finally {
        setLoading(false);
      }
    },
    [loadMyTask]
  );

  useEffect(() => {
    loadProjects();
  }, [loadProjects]);

  // Open drawer for add or edit
  const openDrawer = (id = "", brand = "") => {
    if (id && brand) {
      // Edit mode
      setEditId({ id, brand });
    } else {
      // Add mode
      setEditId(""); // clear previous data
    }
    setTimeSheetDrawerState(true);
  };

  // Close drawer and refresh
  const handleDrawerClose = () => {
    setTimeSheetDrawerState(false);
    loadMyTask();
  };

  // --- Sorting & Pagination Handlers ---
  const handleSortModelChange = useCallback(
    model => {
      if (
        model.length === 0 ||
        model[0]?.field !== sortModel[0]?.field ||
        model[0]?.sort !== sortModel[0]?.sort
      ) {
        dispatch(setSortModel(model));
        dispatch(resetPage());
      }
    },
    [sortModel, dispatch]
  );

  const handlePaginationModelChange = newModel => {
    dispatch(setPagination(newModel));
  };




  //data Grid
  const columns = [
    {
      field: "projectOrTicket",
      headerName: "Project / Ticket",
      flex: 1,
      renderCell: ({ row }) => <>{row.projectOrTicket}</>,
    },

    {
      field: "tms_Task_Department",
      headerName: "Department",
      flex: 1,
      renderCell: ({ row }) => <>{row.tms_Task_Department}</>
    },
    {
      field: "tms_Task_Brand",
      headerName: "Brand",
      flex: 1,
      sortable: false,
      renderCell: ({ row }) => <>{row.tms_Task_Brand}</>

    },
    {
      field: "tms_Task_Desc",
      headerName: "Description",
      sortable: false,
      flex: 1,
      renderCell: ({ row }) => (
        <div
          style={{
            display: "block",
            height: "55px",
            overflowY: "auto",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            padding: "4px",
            lineHeight: "1.5",
          }}
        >
          {row.tms_Task_Desc}
        </div>
      ),
    },

    {
      field: "tms_Task_Entry_Date",
      headerName: "Worked date",
      flex: 1,
      renderCell: ({ row }) => <>  {row.tms_Task_Entry_Date
        ? moment(row.tms_Task_Entry_Date).format("DD-MM-YYYY")
        : null}</>
    },
    {
      field: "tms_Task_Worked_Hours",
      headerName: "Actual Hours",
      flex: 1,
      sortable: false,
      renderCell: ({ row }) => <> {row.tms_Task_Worked_Hours}</>
    },
    {
      field: "action",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      renderCell: ({ row }) => (
        <>
          <Tooltip title="Edit Task">
            <IconButton color="secondary" onClick={() => openDrawer(row._id, row.tms_Task_Brand)}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete Task">
            <IconButton color="error" onClick={() => deleteTimeSheet(row._id, row.tms_Task_Brand)}>
              <Delete />
            </IconButton>
          </Tooltip>
          <Tooltip title="View Task">
            <IconButton color="success" onClick={() => handleViewTask(row)}>
              <GrOverview />
            </IconButton>
          </Tooltip>

        </>
      ),
    }
  ]

  return (
    <>

      <Row className="GeneralHeading">
        <Col md={6}>
          <HeadingTwo>
            <Link className="arrow-btn" onClick={() => navigate(-1)}>
              <ArrowBackIosIcon />
            </Link>
            My Tasks
          </HeadingTwo>
        </Col>
        <Col md={6} className="text-end">
          <Button className="btn primary-btn" onClick={() => openDrawer()}>
            Fill TimeSheet
          </Button>

        </Col>
      </Row>

      <Row className="row GeneralTable">
        <Card className="LayoutCard">
          <Card.Header>
            <Row>
              <Col md={3} className="SearchTextbox">
                <TextField
                  className="w-100"
                  select
                  id="project"
                  label="Project"
                  value={searchFilters.project}
                  onChange={e => {
                    dispatch(resetState()); // Reset pagination, sort, search
                    setSearchFilters({ ...searchFilters, project: e.target.value });
                  }}
                  variant="standard">
                  {projectList.map(project => (
                    <MenuItem key={project._id} value={project._id}>
                      {project.pro_name} / {project.pro_code}
                    </MenuItem>
                  ))}

                </TextField>
              </Col>
              <Col md={3} className="SearchTextbox">
                <TextField
                  className="w-100"
                  select
                  id="department"
                  label="Department"
                  value={searchFilters.department}
                  onChange={e => {
                    dispatch(resetState());
                    setSearchFilters({ ...searchFilters, department: e.target.value })
                  }}
                  variant="standard">
                  {ApproverDepartments.map(resources => (
                    <MenuItem key={resources.value} value={resources.value}>
                      {resources.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Col>
              <Col md={3}>
                <DateRangePicker
                  key={`${dates.startDate.valueOf()}_${dates.endDate.valueOf()}`}
                  initialSettings={{
                    startDate: dates.startDate,
                    endDate: dates.endDate,
                    ranges,
                  }}
                  onApply={(e, picker) => {
                    dispatch(resetState());
                    setDates({
                      startDate: moment(picker.startDate).startOf("day"),
                      endDate: moment(picker.endDate).endOf("day"),
                    });
                  }}
                >
                  <input
                    type="text"
                    value={`${dates.startDate.format(dateFormat)} - ${dates.endDate.format(dateFormat)}`}
                    className="form-control data-range-picker mt-3"
                    readOnly
                  />
                </DateRangePicker>
              </Col>
              <Col md={3}>
                <Button onClick={resetFilters} className="btn secondary-btn mt-3">
                  Reset
                </Button>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>


            {loading ? (
              <HeadingFour className="text-center">Loading...</HeadingFour>
            ) : (
              <Row className="GeneralTable">
                <CommonDataGrid
                  rows={projectTask || []}
                  columns={columns}
                  rowCount={rowCount}
                  loading={loading}
                  paginationModel={paginationModel}
                  onPaginationModelChange={handlePaginationModelChange}
                  sortModel={sortModel}
                  paginationMode="server"
                  onSortModelChange={handleSortModelChange}
                  getRowId={row => row._id}
                />
              </Row>
            )}

            <Drawer anchor="right" open={timeSheetDrawerState} onClose={handleDrawerClose}>
              <ProjectTimeSheetForm handleClose={handleDrawerClose} taskEditId={editId} />
            </Drawer>

          </Card.Body>
        </Card>
      </Row>

      <Modal
        className="modal-xl"
        show={showTaskModal}
        onHide={handleCloseModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Task Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedTask ? (
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Project / Ticket</TableCell>
                    <TableCell>Department</TableCell>
                    <TableCell>Brand</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Worked Date</TableCell>
                    <TableCell align="center">Hours</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{selectedTask.projectOrTicket}</TableCell>
                    <TableCell>{selectedTask.tms_Task_Department}</TableCell>
                    <TableCell>{selectedTask.tms_Task_Brand}</TableCell>
                    <TableCell>{selectedTask.tms_Task_Desc}</TableCell>
                    <TableCell>
                      {selectedTask.tms_Task_Entry_Date
                        ? moment(selectedTask.tms_Task_Entry_Date).format("DD-MM-YYYY")
                        : null}
                    </TableCell>
                    <TableCell align="center">{selectedTask.tms_Task_Worked_Hours}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
}
